import { Toast } from 'zarm';

export const fetchScsHandler = (response, showError) => {
  const { data, message, success } = response;
  if (success) {
    if (showError) return data;
    return response;
  }
  if (showError) {
    message && Toast.show(message);
  }
  return response;
};
